import { render, staticRenderFns } from "./GroupTableForm.vue?vue&type=template&id=74b1fae8&"
import script from "./GroupTableForm.vue?vue&type=script&lang=js&"
export * from "./GroupTableForm.vue?vue&type=script&lang=js&"
import style0 from "./GroupTableForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports